import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import FolderSkeleton from "./FolderSkeleton";
import Folders from "./Folders";
import { Card } from "primereact/card";
import emptyFolderIcon from "../../../assets/empty-file.svg";

const RequestTypeFileDocuments = () => {
  const { id, service_id, type, request_type } = useParams();
  const {
    states,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
    handleClickRequest,
  } = useFileDocuments({ id, service_id, type, request_type });

  return (
    <>
      {states.loading ? (
        <FolderSkeleton />
      ) : (
        <>
          {!states.folders ? (
            <SearchFIles
              fileName={fileName}
              setFileName={setFileName}
              additionaltag={{ entity: [states?.entity_detail?.name] }}
              states={states}
              first={first}
              rows={rows}
              onPageChange={onPageChange}
            />
          ) : (
            <>
              {states.folders.length ? (
                <div className="service-folder-container">
                  {states?.folders?.length > 0 && (
                    <p className="document-sub-heading"> Folders</p>
                  )}
                  {states.loading ? (
                    <FolderSkeleton />
                  ) : (
                    <Folders
                      folders={states?.folders}
                      onFolderClick={handleClickRequest}
                    />
                  )}
                </div>
              ) : (
                <Card>
                  <div className="flex flex-column justify-content-center align-items-center p-5">
                    <div className="no-documents-uploaded-section w-full gap-4">
                      <img src={emptyFolderIcon} alt="empty-folder" />
                      <p className="add-new-entity-heading mb-0">
                        No files here yet
                      </p>
                    </div>
                  </div>
                </Card>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default RequestTypeFileDocuments;
